import type { ChangeOrder, DealPLOverrides, ProposalBuilderData, QBExpense } from '../types';
import type { PurchaseJobPlBucket } from '../types/purchasing';
import { computeChangeOrderBudgetByBucket, isApprovedChangeOrder } from './contractValue';
import type { DesignerInvoiceJobCash } from './designerInvoicePL';
import { purchaseJobMaterialsBudget } from './proposalBucketLineItems';
import { getProposalBucketBudget, sumPurchaseJobBucketPlActual } from './projectPL';

export function jobNodeProposalBudget(
  proposal: ProposalBuilderData | null | undefined,
  changeOrders: ChangeOrder[] | undefined,
  bucket: PurchaseJobPlBucket,
): number {
  if (bucket === 'timber') return purchaseJobMaterialsBudget(proposal, changeOrders);
  const budgetMap = getProposalBucketBudget(proposal);
  (changeOrders || []).forEach(co => {
    if (!isApprovedChangeOrder(co)) return;
    const byBucket = computeChangeOrderBudgetByBucket(co);
    (Object.keys(byBucket) as Array<keyof typeof budgetMap>).forEach(key => {
      budgetMap[key] = (budgetMap[key] || 0) + (byBucket[key] || 0);
    });
  });
  return budgetMap[bucket] || 0;
}

export function jobNodeQbActual(
  expenses: Array<QBExpense & { id?: string }>,
  dealId: string,
  bucket: PurchaseJobPlBucket,
  context?: {
    overrides?: DealPLOverrides | null;
    designerInvoiceJobCash?: DesignerInvoiceJobCash[];
  },
): number {
  return sumPurchaseJobBucketPlActual({
    expenses,
    dealId,
    bucket,
    overrides: context?.overrides,
    designerInvoiceJobCash: context?.designerInvoiceJobCash,
  });
}
